import { Box, CircularProgress } from "@mui/material";

import { useFetchJeopardy } from "../hooks/useFetchJeopardy";
import { PaginationControls } from "../../../shared/components";
import { JeopardyCard } from "./JeopardyCard";
import { useJeopardy } from "../hooks/useJeopardy";
import { useEffect, useMemo, useState } from "react";

export const JeopardyPanel = ({ selectedFilterCode, treeFilterCode }: { selectedFilterCode: string | null; treeFilterCode: string | null }) => {

    const { data, pagination, isLoading, isError, error, changePage, changeRowsPerPage } = useFetchJeopardy({ selectedFilterCode, treeFilterCode });
    const [jeopardyData, setJeopardyData] = useState<any[]>([]);

    const { updateAcknowledgementStatus } = useJeopardy();

    const handleMarkAsRead = async ({ jeopardyId, isRead }: { jeopardyId: string; isRead: boolean; }) => {
        setJeopardyData(prev => prev.map(item => item.id === jeopardyId ? { ...item, is_read: isRead } : item));
        try {
            await updateAcknowledgementStatus({ jeopardyId, isRead });
        } catch (error) {
            setJeopardyData(prev => prev.map(item => item.id === jeopardyId ? { ...item, is_read: !isRead } : item));
        }
    };

    useEffect(() => {
        if (data) setJeopardyData(data);
    }, [data]);

    if (isLoading) {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
                py={2}
                height={"100%"}
            >
                <CircularProgress />
            </Box>
        );
    };

    return (
        <Box display="flex" flexDirection="column" height="100%" overflow="hidden">
            <Box
                sx={{
                    flex: 1,
                    overflowY: "auto",
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2
                }}
            >
                {jeopardyData.map((risk: any, idx: number) => (
                    <JeopardyCard key={idx} jeopardy={risk} handleMarkAsRead={handleMarkAsRead} />
                ))}
            </Box>
            <Box flexShrink={0}>
                <PaginationControls
                    total={pagination.total}
                    rowsPerPage={pagination.limit}
                    currentPage={pagination.page}
                    handlePageChange={changePage}
                    handleRowsPerPage={changeRowsPerPage}
                />
            </Box>
        </Box>
    )
}